import { Routes } from "react-router-dom";
import { BookingRoutes } from "./BookingRoutes";
import ErrorRoutes from "./ErrorRoutes";
import WaitingListRoutes from "./WaitingListRoutes";
import AnfragenManagerCRMRoutes from "./AnfragenManagerCRMRoutes";
import "./GeneralStyles.scss";

export default function AppRoutes() {
    return (
        <Routes>
            {WaitingListRoutes}
            {AnfragenManagerCRMRoutes}
        </Routes>
    );
}
